// 기본 설정값 정의
const DEFAULT_SETTINGS = {
  port: '',
  baudRate: 9600,
  fontSize: 0,
  cutType: 'GS_V_66', // 프린터 커팅 명령어 옵션 추가 (기본값: GS V 66)
};

const SETTINGS_KEY = 'app_settings';

/**
 * 설정 읽기 (localStorage 기반)
 */
export const readSettingFile = () => {
  try {
    const saved = localStorage.getItem(SETTINGS_KEY);
    if (!saved) {
      return DEFAULT_SETTINGS;
    }
    // 기본값과 저장된 값을 병합하여 새 옵션 추가 시 undefined 방지
    return { ...DEFAULT_SETTINGS, ...JSON.parse(saved) };
  } catch (error) {
    console.error('readSettingFile Error:', error);
    return DEFAULT_SETTINGS;
  }
};

/**
 * 설정 저장 (localStorage 기반)
 */
export const writeSettingFile = (newSettings) => {
  try {
    const current = readSettingFile();
    const updated = { ...current, ...newSettings };
    localStorage.setItem(SETTINGS_KEY, JSON.stringify(updated));
    return true;
  } catch (error) {
    console.error('writeSettingFile Error:', error);
    return false;
  }
};